import React, { useEffect } from 'react'

import { useParams } from 'utils/hooks'

import * as UserEvents from 'redux/api/internal/UserEvents'
import { Action } from 'types/GlobalUserEvents'
import { useLocation } from 'react-router-dom'
import { getContext } from 'utils/userEvents'

import MetricSettingsOrganism from 'components_new/organisms/MetricSettings'
import MetricNavigation from 'components_new/organisms/MetricNavigation'
import MetricAbout from 'components_new/organisms/MetricAbout'
import MetricTemplate from 'components_new/templates/MetricTemplate'

const MetricSettings = () => {
  const { search } = useLocation()
  const { id } = useParams<{ id: string }>()
  const searchParams = new URLSearchParams(search)

  useEffect(() => {
    if (id) {
      const context = getContext(searchParams)

      UserEvents.log({
        action: Action.METRIC_SETTINGS_OPENED,
        context: context,
        dashboard_id: null,
        dashboard_group_id: null
      })
    }
  }, [id])

  return (
    <MetricTemplate
      rightSidebar={{
        content: (
          <>
            <MetricNavigation id={id} sx={{ mb: 2 }} />
            <MetricAbout />
          </>
        ),
        size: 'medium'
      }}
      variant="feed"
    >
      <MetricSettingsOrganism />
    </MetricTemplate>
  )
}

export default MetricSettings
